import { useContext } from "react";
import { useParams } from "react-router";
import { GuildRolesAndChannelContext } from "../../../sesh_router";

export function useVoiceChannels() {
	const { server_id } = useParams<{ server_id: string }>();
	const context = useContext(GuildRolesAndChannelContext);
	return context?.get(server_id)?.voice_channels;
}
